export default __webpack_public_path__ + "static/media/data_setting_6.956fc66c.png";